module.exports = __webpack_public_path__ + "img/right-arrow.99100d34.svg";